import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import {
  IconModule,
  OutletRefModule,
  PageComponentModule,
} from '@spartacus/storefront'
import { OutletComponent } from './outlet.component'
import { I18nModule } from '@spartacus/core'

@NgModule({
  imports: [
    CommonModule,
    OutletRefModule,
    PageComponentModule,
    IconModule,
    I18nModule,
  ],
  declarations: [OutletComponent],
  exports: [OutletComponent],
})
export class VsOutletModule {}
